<template>
  <button
    v-tooltip="{ content, placement: 'left', offset: 10 }"
    class="employee-leave-info-button"
    type="button"
    :aria-label="accessibleLabel"
  >
    <span aria-hidden="true">i</span>
  </button>
</template>

<script>
export default {
  name: 'EmployeeLeaveInfoButton',
  props: {
    content: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    accessibleLabel() {
      return this.ariaLabel || this.content
    },
  },
}
</script>

<style lang="scss">
.employee-leave-info-button {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid $ui-line-strong;
  border-radius: 50%;
  background-color: $ui-surface;
  color: $ui-blue;
  font-family: $ui-font-heading;
  font-size: $ui-font-size-metadata;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.employee-leave-info-button:hover,
.employee-leave-info-button:focus-visible {
  border-color: $ui-blue;
  background-color: $ui-blue-soft;
  outline: 0;
}

.employee-leave-info-button:focus-visible {
  box-shadow: 0 0 0 2px rgba(23, 105, 224, .22);
}
</style>
